import { useEffect, useState } from "react";
import { useToast } from "../../../hooks/use-toast";
import { handleHttpError } from "../../../utils/utils";
import CampaignCard from "../../components/ui/campaign-card.ui";
import {
  CampaignStatus,
  type IBrandCampaign,
  useGetBrandCampaignHttp,
} from "../../hooks/http/campaigns/get-brand-campaigns.hook";
import Spinner from "../../../components/spinner.components";
import type { IPagination } from "../../../types/models/pagination.models.types";
import PaginationComponent from "../../components/core/pagination.core";
import { useUserStore } from "../../../store/user.store";

export default function DraftCampaignPartial() {
  const { execute: getBrandCampaignHttp, fetching: gettingBrandCampaign } =
    useGetBrandCampaignHttp();
  const { toast } = useToast();
  const [campaignData, setCampaignData] = useState<IBrandCampaign[]>();
  const [paginationData, setPaginationData] = useState<IPagination>();
  const [pageNo, setPageNo] = useState<number>(1);
  const { brands } = useUserStore();

  async function getBrandCampaign(page: number) {
    if (!brands?.[0]?.id) return;

    const response = await getBrandCampaignHttp({
      body: null,
      queryParams: {
        platform: "solo",
        page: page,
        status: CampaignStatus.brandDraft,
        brandId: brands?.[0]?.id,
      },
    });
    if (!response.success) {
      return handleHttpError(response, toast);
    }
    setCampaignData([...(campaignData || []), ...response.data.campaigns]);
    setPaginationData(response.data.pagination);
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    setCampaignData([]);
    getBrandCampaign(1);
  }, []);

  if (!campaignData?.length && !gettingBrandCampaign)
    return (
      <div className="flex justify-center items-center w-full h-full text-black">
        No campaigns found
      </div>
    );

  if (gettingBrandCampaign && campaignData?.length === 0)
    return (
      <div className="flex justify-center items-center w-full h-full">
        <Spinner width={20} />
      </div>
    );

  return (
    <div className="gap-5 grid grid-cols-1 md:grid-cols-2 p-5">
      {campaignData?.map((campaign) => (
        <CampaignCard
          key={campaign.id}
          campaign={campaign}
          redirect={`/brands/campaigns/${campaign.id}/update`}
        />
      ))}
      <div className="col-span-1 md:col-span-2">
        {paginationData && (
          <PaginationComponent
            fetching={gettingBrandCampaign}
            paginationData={paginationData}
            onClick={() => {
              const nextPage = pageNo + 1;
              setPageNo(nextPage);
              getBrandCampaign(nextPage);
            }}
          />
        )}
      </div>
    </div>
  );
}
